/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsEvent } from '@shure/shared/models';

import { CdmAnalyticsEvents } from './cdm-analytics-events.enum';
import { AnalyticsCommonDeviceInfo } from './common.model';

/**
 * Event to measure how frequently a user launches the managed_gateways dialog
 */
export class ManagedGatewaysDialogLaunchedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.ManagedGatewaysDialogLaunched;
	public readonly properties = {};
}

/**
 * Event to measure how frequently a user cancels out of the Managed Gateways dialog w/out performing any operations.
 */
export class ManagedGatewaysDialogCancelledEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.ManagedGatewaysDialogCancelled;
	public readonly properties: {
		step: 'step_1' | 'step_2' | 'step_3';
	};

	constructor(step: 'step_1' | 'step_2' | 'step_3') {
		this.properties = {
			step: step
		};
	}
}

/**
 * Event to measure how frequently user's add/associate devices with a Gateway device
 */
export class ManagedGatewaysDevicesAddedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.ManagedGatewaysDevicesAdded;
	public readonly properties: {
		gateway_device: AnalyticsCommonDeviceInfo;
		devices: AnalyticsCommonDeviceInfo[];
	};

	constructor(gatewayDevice: AnalyticsCommonDeviceInfo, devices: AnalyticsCommonDeviceInfo[]) {
		this.properties = {
			gateway_device: gatewayDevice,
			devices: devices
		};
	}
}

/**
 * Event to measure how frequently user's dissasociate devices with a Gateway device
 */
export class ManagedGatewaysDevicesRemovedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.ManagedGatewaysDevicesRemoved;
	public readonly properties: {
		gateway_device: AnalyticsCommonDeviceInfo;
		devices: AnalyticsCommonDeviceInfo[];
	};

	constructor(gatewayDevice: AnalyticsCommonDeviceInfo, devices: AnalyticsCommonDeviceInfo[]) {
		this.properties = {
			gateway_device: gatewayDevice,
			devices: devices
		};
	}
}

/**
 * Event to measure how frequently a user transfers a device from one Gateway device to another.
 */
export class ManagedGatewaysDevicesTransferredEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.ManagedGatewaysDevicesTransferred;
	public readonly properties: {
		orig_gateway_device: AnalyticsCommonDeviceInfo;
		new_gateway_device: AnalyticsCommonDeviceInfo;
		devices: AnalyticsCommonDeviceInfo[];
	};

	constructor(
		origGatewayDevice: AnalyticsCommonDeviceInfo,
		newGatewayDevice: AnalyticsCommonDeviceInfo,
		devices: AnalyticsCommonDeviceInfo[]
	) {
		this.properties = {
			orig_gateway_device: origGatewayDevice,
			new_gateway_device: newGatewayDevice,
			devices: devices
		};
	}
}
